<template>
  <div class="main-body">
    <jm-crumbs />
    <div class="operation" v-if="hasOptArea">
      <el-menu :default-active="active" class="tab-head" mode="horizontal" @select="fetchData">
        <el-menu-item index="all">
          <span>全部</span>
        </el-menu-item>
        <el-menu-item index="today">
          <span>{{ $t('tab.今日面试') }} (</span>
          <span :class="{hasRemind: count.today > 0}">{{ count.today || 0 }}</span>
          <span>)</span>
        </el-menu-item>
        <el-menu-item index="tomorrow">
          <span>{{ $t('tab.明日面试') }} (</span>
          <span :class="{hasRemind: count.tomorrow > 0}">{{ count.tomorrow || 0 }}</span>
          <span>)</span>
        </el-menu-item>
        <el-menu-item index="wait">
          <span>{{ $t('tab.待排期') }} (</span>
          <span :class="{hasRemind: count.wait > 0}">{{ count.wait || 0 }}</span>
          <span>)</span>
        </el-menu-item>
        <el-menu-item index="wait_interviewing">
          <span>{{ $t('tab.待面试') }} (</span>
          <span :class="{hasRemind: count.progress_1 > 0}">{{ count.progress_1 || 0 }}</span>
          <span>)</span>
        </el-menu-item>
        <el-menu-item index="makeResult">
          <span>{{ $t('tab.待确认结果') }} (</span>
          <span :class="{hasRemind: count.progress_3 > 0}">{{ count.progress_3 || 0 }}</span>
          <span>)</span>
        </el-menu-item>
        <el-menu-item index="uploadResult">
          <span>{{ $t('tab.待上传合格证') }} (</span>
          <span :class="{hasRemind: count.progress_4 > 0}">{{ count.progress_4 || 0 }}</span>
          <span>)</span>
        </el-menu-item>
        <el-menu-item index="reset" v-show="false">
          <span>none</span>
        </el-menu-item>
      </el-menu>
    </div>
    <filter-form :filter-data.sync="searchForm" :refresh.sync="refresh" @resetActive="resetActive"/>
    <jm-tableList
      url="/interview/plan/dataTable"
      :refresh.sync="refresh"
      :current-page.sync="currentPage"
      row-key="id"
      :search-data="searchForm"
      :row-class-name="tableRowClassName"
    >
      <el-table-column
        prop="id"
        label="面试记录"
        slot="firstColumn"
      >
        <template slot-scope="scope">
          <el-button @click="showInterHistory(scope.row)" class="special-button" size="mini" type="primary">
            面试记录
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        slot="lastColumn"
        label="操作"
        :min-width="400"
        class-name="scope-button-list"
      >
        <template slot-scope="scope">
          <el-row>
            <el-button
              v-if="$hasPermission([107])"
              size="mini"
              type="warning"
              @click="interviewFormPage(scope.row)">
              {{ $t('message.面试采集表') }}
            </el-button>
            <el-button
              size="mini"
              type="primary"
              @click="showSignupTable(scope.row)"
            >{{ $t('message.报名表') }}</el-button>
            <el-button size="mini" type="warning" @click="showResultDialog(scope.row)">{{ $t('message.面试结果') }}</el-button>
            <template v-if="!scope.row.is_canceled">
              <el-button
                v-show="scope.row.interview_progress == 1 && !scope.row.interview_result"
                size="mini"
                type="primary"
                @click="setInterviewTime(scope.row)"
              >排期</el-button>
              <template v-if="$hasPermission([108])">
                <el-button
                  size="mini"
                  type="primary"
                  @click="confirmInterview(scope.row.id, 1)"
                  :disabled="scope.row.interview_way === 2"
                >{{ $t('message.系统视频面试') }}</el-button>
                <el-button
                  size="mini"
                  type="primary"
                  @click="confirmInterview(scope.row.id, 2)"
                  :disabled="scope.row.interview_way === 1"
                >{{ $t('message.系统语音面试') }}</el-button>
              </template>
              <template v-if="$hasPermission([107])">
                <el-button size="mini" type="primary" v-show="scope.row.is_sent < 2" @click="sendToSchool(scope.row)">{{ $t('message.发送校方') }}</el-button>
                <el-button
                  size="mini"
                  type="warning"
                  v-show="scope.row.video_url"
                  @click="openVideoDialog(scope.row)"
                >查看录像</el-button>
                <el-button
                  size="mini"
                  v-show="scope.row.is_locked == 1"
                  type="danger"
                  @click="lockSignupTable(scope.row)"
                >取消锁定</el-button>
                <el-button
                  size="mini"
                  v-show="scope.row.is_locked == 0"
                  type="primary"
                  @click="lockSignupTable(scope.row)"
                >锁定报名表</el-button>
                <!-- <el-button size="mini" type="danger" @click="cancelInterview(scope.row.id)">
                  {{ $t('message.取消面试') }}
                </el-button> -->
              </template>
            </template>
            <el-button v-permission="[107]" size="mini" type="danger" @click="cancelInterview(scope.row.id, !scope.row.is_canceled)">
              {{ scope.row.is_canceled ? '面试官方恢复' : '面试官方取消' }}
            </el-button>
            <el-button v-permission="[107,108]" size="mini" type="warning" @click="showStatusDialog(scope.row)">{{ $t('message.面试状态') }}</el-button>
          </el-row>
        </template>
      </el-table-column>
    </jm-tableList>
    <result-dialog :visible.sync="resultDialogVisible" :interview="currentPlan" />
    <status-dialog :visible.sync="statusDialogVisible" :interview="currentPlan" />
    <div class="interview-history-bg">
      <div>

      </div>
    </div>
    <el-dialog
      title="面试记录"
      :visible.sync="interviewHistoryLock"
      @close="CloseInterviewWindow"
      width="50%">
      <div class="history-info-area" v-if="pageData">
        <div class="left">
          <h3>老师：{{ pageData.teacher_name }}</h3>
          <div class="info-content">
            <span>上线：{{ pageData.teacher.online === 1 ? '是' : '否' }}</span>
            <span>进入房间：{{ pageData.teacher.enter === 1 ? '是' : '否' }}</span>
            <span>设备：{{ pageData.teacher.device }}</span>
            <span>麦克风：{{ pageData.teacher.enter !== 1 ? '未知' : pageData.teacher.mike === 1 ? '允许' : '禁止' }}</span>
            <span>摄像头：{{ pageData.teacher.enter !== 1 ? '未知' : pageData.teacher.camera === 1 ? '允许' : '禁止' }}</span>
          </div>
        </div>
        <div class="left special">
          <h3>学生：{{ studentInfo.sname }}&ensp;面试ID：{{ studentInfo.interid }}&ensp;用户ID：{{ studentInfo.sid }}</h3>
          <div class="info-content">
            <span>上线：{{ pageData.student.online === 1 ? '是' : '否' }}</span>
            <span>进入房间：{{ pageData.student.enter === 1 ? '是' : '否' }}</span>
            <span>设备：{{ pageData.student.device }}</span>
            <span>麦克风：{{ pageData.teacher.enter !== 1 ? '未知' : pageData.student.mike === 1 ? '允许' : '禁止' }}</span>
            <span>摄像头：{{ pageData.teacher.enter !== 1 ? '未知' : pageData.student.camera === 1 ? '允许' : '禁止' }}</span>
          </div>
        </div>
        <div class="info-list">
          <span v-for="(item, index) in pageData.records" :key="index" :class="item.model === 2 ? 'color-green' : item.model === 3 ? 'color-red' : ''" >{{ item.time }}{{ item.content }}</span>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="CloseInterviewWindow">关 闭</el-button>
      </span>
    </el-dialog>
    <schedule-dialog
      :interview="currentPlan"
      :visible.sync="scheduleDialogVisible"
      @after-set="refresh = true"
    />
    <signup-table-dialog :interview="currentPlan" :visible.sync="signupDialogVisible" />
    <video-player :visible.sync="videoDialogVisible" :videourl="videoUrl" />
    <div class="join-interview-bg" v-show="joinInterLock">
      <div class="join-interview">
        <h3>面试开始通知</h3>
        <div class="avatar-area">
          <img src="@/assets/images/avatar-teacher-interview-default.png" alt="">
          <div id="fountainG">
            <div id="fountainG_1" class="fountainG"></div>
            <div id="fountainG_2" class="fountainG"></div>
            <div id="fountainG_3" class="fountainG"></div>
            <div id="fountainG_4" class="fountainG"></div>
            <div id="fountainG_5" class="fountainG"></div>
            <div id="fountainG_6" class="fountainG"></div>
            <div id="fountainG_7" class="fountainG"></div>
            <div id="fountainG_8" class="fountainG"></div>
          </div>
          <img src="@/assets/images/avatar-student-interview-default.png" alt="">
        </div>
        <h4>您的面试已开始，请尽快进入房间</h4>
        <a :href="joinLink" target="_blank">开始面试</a>
      </div>
    </div>
  </div>
</template>

<script>
import jmTableList from '@/components/data/tableList.vue';
import filterForm from '../components/filterForm';
import resultDialog from '../components/resultDialog';
import statusDialog from '../components/statusDialog';
import scheduleDialog from '../components/scheduleDialog';
import signupTableDialog from '../components/signupTableDialog';
import videoPlayer from '../components/videoPlayer.vue';
import '@/assets/css/index.css';
import { mapGetters } from 'vuex';

export default {
  components: {
    jmTableList,
    filterForm,
    resultDialog,
    statusDialog,
    scheduleDialog,
    signupTableDialog,
    videoPlayer
  },

  data() {
    return {
      resultDialogVisible: false, // 面试结果
      statusDialogVisible: false, // 面试状态
      scheduleDialogVisible: false, // 排期确认
      signupDialogVisible: false, // 报名表
      videoDialogVisible: false,
      interviewHistoryLock: false,
      searchForm: {},
      count: {
        today_wait: 0,
        today_already: 0,
        today_intention: 0,
        today_sign: 0
      },
      active: 'all',
      currentPage: 1,
      refresh: false,
      currentPlan: {},
      videoUrl: '',
      studentInfo: {
        sname: '',
        sid: '',
        interid: '',
        tname: ''
      },
      interListTimer: null,
      joinInterLock: false,
      joinLink: '',
      pageData: null,
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    typeInterface() {
      return '';
    },
    url() {
      return `/training/customer/${this.typeInterface}`;
    },
    /**
     * 有操作域
     */
    hasOptArea() {
      return this.$route.name === 'homepage';
    }
  },
  methods: {
    tableRowClassName({ row }) {
      // 面试官
      if (row.is_canceled) {
        return 'interview-cancel-row';
      }

      return '';
    },
    fetchCount() {
      this.$http
        ._get({
          url: '/interview/plan/getAggregateData'
        })
        .then(({ data }) => {
          this.count = data;
        });
    },
    fetchData(key) {
      if (this.active === key) {
        return false;
      }
      this.searchForm = {};
      switch (key) {
        case 'wait_send':
          this.searchForm.is_sent = 1; // 待发送
          break;
        case 'today':
          this.searchForm.interview_time = this.count.today_condition; // 今天面试
          break;
        case 'tomorrow':
          this.searchForm.interview_time = this.count.tomorrow_condition; // 今天面试
          break;
        case 'wait_interviewing':
          this.searchForm.interview_progress = 1; // 待面试
          break;
        case 'wait': // 待排期
          this.searchForm.schedule = 1;
          break;
        case 'makeResult':
          this.searchForm.interview_progress = 2; // 待确认结果
          break;
        case 'uploadResult':
          this.searchForm.upload_result = 1; // 待上传合格证
          break;
        default:
          break;
      }
      this.active = key;
      this.currentPage = 1;
      this.refresh = true;
    },
    /**
     * 确认面试方式
     */
    async confirmInterview(id, type) {
      let text = '系统语音面试';
      if (type === 1) {
        text = '系统视频面试';
      }
      try {
        await this.$confirm(
          this.$t('message.change_interview_way', { way: this.$t(`message.${text}`) }),
          '提示',
          {
            confirmButtonText: this.$t('message.确认'),
            cancelButtonText: this.$t('message.取消'),
            type: 'warning'
          }
        );
      // eslint-disable-next-line no-empty
      } catch (e) {
        return false;
      }

      await this.$http._post({
        url: '/interview/plan/changeInterviewWay',
        data: { id, type }
      });
      this.refresh = true;
      // eslint-disable-next-line no-unused-expressions
      window.open(`/rtc/${id}&${type}`, '_blank').location;
    },
    hasSignupTable(interview) {
      if (!interview.signup_form && !interview.signup_table) {
        this.$message.error('没有报名表');
        return false;
      }
      return true;
    },
    /**
     * 显示报名表
     */
    showSignupTable(interview) {
      let isSpecial = interview.is_special;
      // 非特殊学校
      if (!isSpecial) {
        if (!this.hasSignupTable(interview)) {
          return false;
        }
        // eslint-disable-next-line no-unused-expressions
        window.open(`/table/${interview.user_id}?msid=${interview.id}&is_locked=${interview.is_locked}`, '_blank').location;
        return true;
      }
      // 面试官
      if (this.$hasPermission([108], true)) {
        if (isSpecial) {
          let signupTable = interview.signup_table;
          signupTable &&
            this.$http.getFile({
              url: signupTable.file_path,
              filename: signupTable.filename
            });
          return true;
        }
      }
      this.currentPlan = interview;
      this.signupDialogVisible = true;
    },
    async sendToSchool(interview) {
      if (!this.hasSignupTable(interview)) {
        return false;
      }

      try {
        await this.$confirm('确定要发送校方吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await this.$http._post({
          url: '/interview/plan/sendToSchool',
          data: {
            id: interview.id
          }
        });
        this.refresh = true;
        this.$message.success('发送成功');
      } catch (e) {
        console.log(e);
      }
    },
    setInterviewTime(interview) {
      this.currentPlan = interview;
      this.scheduleDialogVisible = true;
    },
    /**
     * 锁定报名报
     */
    async lockSignupTable(interview) {
      const { id, is_locked: isLocked } = interview;
      let text = '确定要锁定该报名表吗？';
      if (isLocked) {
        text = '确定要解锁该报名表吗？';
      }
      try {
        await this.$confirm(text, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await this.$http._post({
          url: '/interview/plan/lockSignupTable',
          data: { id }
        });
        this.refresh = true;
      } catch (e) {
        console.log(e);
      }
    },

    /**
     * 取消面试
     */
    async cancelInterview(id, newStatus) {
      try {
        const message = `确定要${newStatus ? '取消' : '恢复此'}面试吗？这是真的取消面试啊！`;
        await this.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await this.$http._post({
          url: '/interview/plan/cancelInterview',
          data: { id, newStatus }
        });
        this.refresh = true;
      } catch (e) {
        console.log(e);
      }
    },
    showResultDialog(plan) {
      this.currentPlan = plan;
      this.resultDialogVisible = true;
    },
    interviewFormPage(plan) {
      let crmId = plan.user_id;
      this.$http._post({
        url: '/interview/Form/editSigUrl',
        data: { crm_id: crmId }
      }).then(({ data }) => {
        window.open(data, '_blank');
      });
    },
    showStatusDialog(plan) {
      this.currentPlan = plan;
      this.statusDialogVisible = true;
    },
    /**
     * 查看录像
     */
    async openVideoDialog(interview) {
      const { data } = await this.$http._post({
        url: '/interview/plan/getVideoUrl',
        data: { url: interview.video_url }
      });
      this.videoUrl = data;
      this.videoDialogVisible = true;
    },
    // 打开面试记录
    showInterHistory(info) {
      console.log(info);
      let that = this;
      clearInterval(this.interListTimer);
      this.interListTimer = setInterval(() => {
        that.getInterList(info.id);
      }, 5000);
      this.studentInfo.sname = info.custom_name;
      this.studentInfo.sid = info.user_id;
      this.studentInfo.interid = info.id;
      this.studentInfo.tname = info.teacher_name;
      this.interviewHistoryLock = true;
      this.getInterList(info.id);
    },
    // 获取面试记录
    getInterList(interid) {
      this.$http._post({
        url: '/interview/plan/fetchInterviewStatus',
        data: { id: interid }
      }).then((data) => {
        this.pageData = data.data;
        console.log(data);
      });
    },
    // 关闭面试记录
    CloseInterviewWindow() {
      this.interviewHistoryLock = false;
      clearInterval(this.interListTimer);
    },
    resetActive(isReset) {
      this.active = 'reset';
      if (isReset === 1) {
        this.active = 'all';
      }
    }
  },
  mounted() {
    if (this.$route.name !== 'wait_sent') {
      this.fetchCount();
      const interviewId = this.$route.query.id;
      const result = this.$route.query.r;
      if (interviewId && result) {
        this.$http._get({
          url: '/interview/plan/read', data: { id: interviewId }
        }).then(({ data }) => this.showResultDialog(data));
      }
    } else {
      this.searchForm = { result_null: 1 };
    }
  },
  watch: {
    resultDialogVisible(value) {
      !value && (this.refresh = true);
    },
    signupDialogVisible(value) {
      !value && (this.refresh = true);
    },
    videoDialogVisible(value) {
      !value && (this.refresh = true);
    },
    statusDialogVisible(value) {
      !value && (this.refresh = true);
    },
  }
};
</script>

<style>
.remind form {
  margin: 0.5em 0;
}

.remind .operation {
  position: relative;
  margin-bottom: 15px;
  padding-right: 120px;
}

.remind .operation:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 0;
  display: block;
  width: 100%;
  border-bottom: 1px solid #d0dee5;
}

.remind .tab-head {
  position: relative;
  z-index: 1;
  background-color: transparent;
}

.remind .tab-head span {
  line-height: 12px;
}
.el-table .interview-cancel-row {
  color: #c0c4cc;
}
.special-button{
  padding:7px 5px;
  margin:0;
}
.history-info-area .left{
  float: left;
  width: 50%;
  text-align: center;
  color: #44a4bc;
}
.history-info-area .left.special{
  color:#f6a54f
}
.history-info-area .left h3{
  font-size: 15px;
  font-weight: normal;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
  white-space: nowrap;
}
.history-info-area .info-list{
  clear: both;
  text-align: left;
  font-size: 13px;
  padding-top: 15px;
  border-top:1px solid #f0f0f0;
  max-height: 300px;
  overflow-y: auto;
}
.history-info-area .info-list span{
  display: block;
  line-height:22px;
  color: #333;
}
.history-info-area .info-list span.color-green{
  color:green;
}
.history-info-area .info-list span.color-red{
  color:red
}
.history-info-area .info-content{
  padding: 10px 0;
  overflow: hidden;
}
.history-info-area .info-content span{
  display: block;
  line-height: 20px;
}
#fountainG{
  position:relative;
  width:54px;
  height:7px;
  margin:auto;
}

.fountainG{
  position:absolute;
  top:0;
  background-color:rgb(0,0,0);
  width:7px;
  height:7px;
  animation-name:bounce_fountainG;
  -o-animation-name:bounce_fountainG;
  -ms-animation-name:bounce_fountainG;
  -webkit-animation-name:bounce_fountainG;
  -moz-animation-name:bounce_fountainG;
  animation-duration:1.5s;
  -o-animation-duration:1.5s;
  -ms-animation-duration:1.5s;
  -webkit-animation-duration:1.5s;
  -moz-animation-duration:1.5s;
  animation-iteration-count:infinite;
  -o-animation-iteration-count:infinite;
  -ms-animation-iteration-count:infinite;
  -webkit-animation-iteration-count:infinite;
  -moz-animation-iteration-count:infinite;
  animation-direction:normal;
  -o-animation-direction:normal;
  -ms-animation-direction:normal;
  -webkit-animation-direction:normal;
  -moz-animation-direction:normal;
  transform:scale(.3);
  -o-transform:scale(.3);
  -ms-transform:scale(.3);
  -webkit-transform:scale(.3);
  -moz-transform:scale(.3);
  border-radius:4px;
  -o-border-radius:4px;
  -ms-border-radius:4px;
  -webkit-border-radius:4px;
  -moz-border-radius:4px;
}

#fountainG_1{
  left:0;
  animation-delay:0.6s;
  -o-animation-delay:0.6s;
  -ms-animation-delay:0.6s;
  -webkit-animation-delay:0.6s;
  -moz-animation-delay:0.6s;
}

#fountainG_2{
  left:7px;
  animation-delay:0.75s;
  -o-animation-delay:0.75s;
  -ms-animation-delay:0.75s;
  -webkit-animation-delay:0.75s;
  -moz-animation-delay:0.75s;
}

#fountainG_3{
  left:13px;
  animation-delay:0.9s;
  -o-animation-delay:0.9s;
  -ms-animation-delay:0.9s;
  -webkit-animation-delay:0.9s;
  -moz-animation-delay:0.9s;
}

#fountainG_4{
  left:20px;
  animation-delay:1.05s;
  -o-animation-delay:1.05s;
  -ms-animation-delay:1.05s;
  -webkit-animation-delay:1.05s;
  -moz-animation-delay:1.05s;
}

#fountainG_5{
  left:27px;
  animation-delay:1.2s;
  -o-animation-delay:1.2s;
  -ms-animation-delay:1.2s;
  -webkit-animation-delay:1.2s;
  -moz-animation-delay:1.2s;
}

#fountainG_6{
  left:34px;
  animation-delay:1.35s;
  -o-animation-delay:1.35s;
  -ms-animation-delay:1.35s;
  -webkit-animation-delay:1.35s;
  -moz-animation-delay:1.35s;
}

#fountainG_7{
  left:40px;
  animation-delay:1.5s;
  -o-animation-delay:1.5s;
  -ms-animation-delay:1.5s;
  -webkit-animation-delay:1.5s;
  -moz-animation-delay:1.5s;
}

#fountainG_8{
  left:47px;
  animation-delay:1.64s;
  -o-animation-delay:1.64s;
  -ms-animation-delay:1.64s;
  -webkit-animation-delay:1.64s;
  -moz-animation-delay:1.64s;
}

@keyframes bounce_fountainG{
  0%{
    transform:scale(1);
    background-color:rgba(0,0,0,0.46);
  }

  100%{
    transform:scale(.3);
    background-color:rgb(255,255,255);
  }
}

@-o-keyframes bounce_fountainG{
  0%{
    -o-transform:scale(1);
    background-color:rgba(0,0,0,0.46);
  }

  100%{
    -o-transform:scale(.3);
    background-color:rgb(255,255,255);
  }
}

@-ms-keyframes bounce_fountainG{
  0%{
    -ms-transform:scale(1);
    background-color:rgba(0,0,0,0.46);
  }

  100%{
    -ms-transform:scale(.3);
    background-color:rgb(255,255,255);
  }
}

@-webkit-keyframes bounce_fountainG{
  0%{
    -webkit-transform:scale(1);
    background-color:rgba(0,0,0,0.46);
  }

  100%{
    -webkit-transform:scale(.3);
    background-color:rgb(255,255,255);
  }
}

@-moz-keyframes bounce_fountainG{
  0%{
    -moz-transform:scale(1);
    background-color:rgba(0,0,0,0.46);
  }

  100%{
    -moz-transform:scale(.3);
    background-color:rgb(255,255,255);
  }
}
.join-interview-bg{
  position: fixed;
  left:0;
  top:0;
  z-index: 11;
  width: 100%;
  height:100%;
  background: rgba(0,0,0,.6);
}
.join-interview{
  position: fixed;
  width: 350px;
  text-align: center;
  padding: 34px;
  left:50%;
  top:50%;
  transform: translate(-50%,-50%);
  background: #fff;
  -webkit-border-radius: 10px; -moz-border-radius: 10px; border-radius: 10px;
}
.join-interview .avatar-area{
  display: flex;
  justify-content: space-around;
  padding: 30px 25px;
}
.join-interview .avatar-area > img{
  width: 60px;
  height:60px;
}
.join-interview h4{
  font-weight: normal;
  font-size: 15px;
}
.join-interview > a{
  display: block;
  background: #2196f3;
  color: #fff;
  font-size: 18px;
  height:45px;
  line-height: 45px;
  margin-top: 30px;
  -webkit-border-radius: 5px; -moz-border-radius: 5px; border-radius: 5px;
}
.join-interview > a:hover{
  opacity:.8;
}
</style>
